export function Placeholder() {
  return <div style={style} />;
}

////
const style = {
  minHeight: '568px',
};
